import React from 'react';
import { Link } from 'react-router-dom';
function Academics() {
  const getSubjects = [
    "English Home Language",
    "Mathematics",
    "Natural Sciences",
    "Social Sciences",
    "Technology",
    "Creative Arts",
    "Life Orientation",
    "Second Additional Language"
  ];

  return (
    <div style={{ backgroundColor: '#7494b4ff', minHeight: '100vh', paddingTop: '30px', paddingBottom: '30px' }}>
      <div className="container text-white">
        <h1 className="text-center mb-4">Academics at Highlands High School</h1>
        <p>
          At Highlands High School, academics are the cornerstone of our commitment to nurturing well-rounded, future-ready learners.
          We aim to offer every student a solid foundation through our <strong>General Education and Training (GET)</strong> phase and
          personalized growth paths in the <strong>Further Education and Training (FET)</strong> phase.
        </p>

        {/* GET Subjects Box */}
        <div className="card bg-white border-0 shadow-sm mb-5">
          <div className="card-body">
            <h3 className="card-title text-center text-info mb-3">General Education and Training (GET) Subjects</h3>
            <p className="text-center mb-4 text-dark">
              All students complete the following core subjects during the GET phase (Grades 8 & 9):
            </p>
            <ul className="list-group list-group-horizontal justify-content-center flex-wrap gap-2">
              {getSubjects.map((subject, idx) => (
                <li key={idx} className="list-group-item flex-fill text-center" style={{ minWidth: '180px' }}>
                  {subject}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* FET Phase */}
        <h2 className="mt-5">Further Education and Training (FET) Phase</h2>
        <p>
          Students entering the FET Phase choose one academic stream package, complete <strong>Life Orientation</strong> (compulsory),
          and select <strong>two languages</strong> — one as a Home Language and one as a First Additional Language (FAL).
        </p>

        {/* Stream Packages */}
        <div className="row g-4 mt-4">
          {/* Science */}
          <div className="col-md-4">
            <div className="card h-100 bg-white border-0 shadow-sm">
              <div className="card-body">
                <h5 className="card-title text-primary text-center">🔬 Science Stream</h5>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">Physical Sciences</li>
                  <li className="list-group-item">Life Sciences</li>
                  <li className="list-group-item">Geography</li>
                  <li className="list-group-item">Mathematics</li>
                  <li className="list-group-item">Tourism</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Commerce */}
          <div className="col-md-4">
            <div className="card h-100 bg-white border-0 shadow-sm">
              <div className="card-body">
                <h5 className="card-title text-success text-center">💼 Commerce Stream</h5>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">Accounting</li>
                  <li className="list-group-item">Business Studies</li>
                  <li className="list-group-item">Economics</li>
                  <li className="list-group-item">Mathematical Literacy</li>
                  <li className="list-group-item">Tourism</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Humanities */}
          <div className="col-md-4">
            <div className="card h-100 bg-white border-0 shadow-sm">
              <div className="card-body">
                <h5 className="card-title text-danger text-center">📚 Humanities Stream</h5>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">History</li>
                  <li className="list-group-item">Geography</li>
                  <li className="list-group-item">Life Sciences</li>
                  <li className="list-group-item">Mathematical Literacy</li>
                  <li className="list-group-item">Tourism</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Life Orientation */}
        <div className="text-center mt-5">
          <h4 className="text-decoration-underline">✅ Life Orientation</h4>
          <p className="text-white-50">All FET learners take Life Orientation as a compulsory subject.</p>
        </div>

        {/* Language Options */}
        <div className="mt-5">
          <h4 className="text-center">🌍 Language Selection</h4>
          <p className="text-center text-white-50">
            Students choose one Home Language and one First Additional Language (FAL).
          </p>
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="card bg-white shadow-sm border-0">
                <div className="card-body text-center">
                  <h5 className="card-title">🏠 Home Language Options</h5>
                  <ul className="list-unstyled mb-0">
                    <li>• English (HL)</li>
                    <li>• Sepedi (HL)</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="card bg-white shadow-sm border-0">
                <div className="card-body text-center">
                  <h5 className="card-title">💬 First Additional Language (FAL)</h5>
                  <ul className="list-unstyled mb-0">
                    <li>• English (FAL)</li>
                    <li>• Afrikaans (FAL)</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div style={{ backgroundColor: '#cccccc56' }} className="text-dark text-center py-4 mt-5 rounded">
  <h5>Need help choosing your academic stream?</h5>
  <p className="mb-2">Our academic advisors are here to guide you.</p>
  <Link to="/high-school/contact" className="btn btn-dark">Contact Us</Link>
</div>

      </div>
    </div>
  );
}

export default Academics;
